import { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/admin/Layout';
import ContextStates from '../../context/ContextStates';
import { AiOutlinePlus, AiOutlineSearch } from 'react-icons/ai'
import ListadoUsuarios from '../../components/admin/listadoUsuarios';
import { RiFileExcel2Line } from 'react-icons/ri'

const AdminUsuarios = () => {

    const { setViewOpen, setFormView, roles, idUsuario, setIdUsuario, buscarUsuario, setBuscarUsuario } = useContext(ContextStates);
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('pvp_id'))
            setIdUsuario(localStorage.getItem('pvp_id'));
    }, [])

    useEffect(() => {
        if (!roles.includes("1")) {
            navigate("/", { replace: true });
        }
    }, [idUsuario])

    const Alta = () => {
        setFormView(20);
        setViewOpen(true);
    }



    return (
        <Layout
            pagina="Usuarios"
        >
            <div className="w-full">
                <h1 className="mt-16 mb-5 text-gray-600 text-2xl text-center">Administración de Usuarios</h1>
                <div className='w-full h-screen mt-2 bg-white'>
                    <div className='w-full md:h-16 py-2 md:px-10 bg-slate-50 md:flex'>
                        <button
                            className='bg-indigo-600 mx-auto hover:bg-indigo-400 p-3 rounded-md text-white uppercase flex'
                            onClick={() => Alta(true)}
                        >
                            <AiOutlinePlus className='text-2xl mr-2' />
                            Agregar Usuario
                        </button>
                        <div className='py-3 mt-4 md:mt-0 rounded-3xl bg-white w-11/12 md:w-1/3 mx-auto border border-gray-300 px-3 flex'>
                            <input
                                type="text"
                                className='w-11/12 outline-none'
                                value={buscarUsuario}
                                placeholder="Buscar Usuario"
                                onChange={(e) => setBuscarUsuario(e.target.value)}
                            />
                            <AiOutlineSearch className='ml-auto text-2xl' />
                        </div>
                    </div>
                    <div className='w-full h-full p-1 md:p-10 bg-white'>
                        <ListadoUsuarios />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default AdminUsuarios